"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _core = require("@mantine/core");
var _clsx = /*#__PURE__*/ _interop_require_default(require("clsx"));
var _editTopNavmodulecss = /*#__PURE__*/ _interop_require_default(require("../../../dist/assets/components/editTopNav.module.css"));
var _title = /*#__PURE__*/ _interop_require_default(require("../title"));
var _badgeCollinson = /*#__PURE__*/ _interop_require_default(require("../badge/badgeCollinson"));
var _icons = require("../../assets/icons");
var _skipLink = /*#__PURE__*/ _interop_require_default(require("../skipLink"));
var _outletSubtitle = /*#__PURE__*/ _interop_require_default(require("../outletSubtitle"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var EditTopNav = function(param) {
    var _param_isCollinson = param.isCollinson, isCollinson = _param_isCollinson === void 0 ? true : _param_isCollinson, _param_hasPreview = param.hasPreview, hasPreview = _param_hasPreview === void 0 ? false : _param_hasPreview, isEdited = param.isEdited, isDraftEdited = param.isDraftEdited, isWithoutSectionStatus = param.isWithoutSectionStatus, isValid = param.isValid, title = param.title, location = param.location, className = param.className, _param_titleID = param.titleID, titleID = _param_titleID === void 0 ? "main" : _param_titleID, onClickExit = param.onClickExit, onClickPreview = param.onClickPreview, onClickSave = param.onClickSave, onClickDiscard = param.onClickDiscard, showForm = param.showForm, invalidSections = param.invalidSections, hasIncompleteSections = param.hasIncompleteSections;
    return /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Box, {
        component: "header",
        role: "banner",
        className: (0, _clsx.default)([
            _editTopNavmodulecss.default.topNav,
            className
        ]),
        children: [
            /*#__PURE__*/ (0, _jsxruntime.jsx)(_skipLink.default, {
                titleID: titleID
            }),
            /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Box, {
                className: _editTopNavmodulecss.default.leftSide,
                children: [
                    /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Box, {
                        className: _editTopNavmodulecss.default.editing,
                        children: [
                            /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Box, {
                                className: _editTopNavmodulecss.default.iconContainer,
                                children: /*#__PURE__*/ (0, _jsxruntime.jsx)(_icons.EditDetailsIcon, {
                                    width: 20,
                                    height: 20,
                                    "aria-hidden": "true"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Text, {
                                className: _editTopNavmodulecss.default.textEditing,
                                children: "EDITING"
                            }),
                            isCollinson && /*#__PURE__*/ (0, _jsxruntime.jsx)(_badgeCollinson.default, {
                                size: "small",
                                inverted: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Box, {
                        className: _editTopNavmodulecss.default.titleContainer,
                        children: [
                            /*#__PURE__*/ (0, _jsxruntime.jsx)(_title.default, {
                                order: 1,
                                className: _editTopNavmodulecss.default.title,
                                children: title
                            }),
                            /*#__PURE__*/ (0, _jsxruntime.jsx)(_outletSubtitle.default, {
                                location: location
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Flex, {
                gap: 16,
                className: _editTopNavmodulecss.default.btnContainer,
                children: isWithoutSectionStatus || isValid || isDraftEdited && !isEdited && !showForm && !hasIncompleteSections ? /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Button, {
                    variant: "outline",
                    onClick: onClickExit,
                    leftSection: /*#__PURE__*/ (0, _jsxruntime.jsx)(_icons.Close, {
                        "aria-hidden": "true"
                    }),
                    className: _editTopNavmodulecss.default.btnExit,
                    children: "Exit"
                }) : /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Stack, {
                    gap: 16,
                    w: "100%",
                    children: [
                        /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Flex, {
                            gap: 16,
                            className: _editTopNavmodulecss.default.editedBtnContainer,
                            children: [
                                hasPreview && /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Button, {
                                    variant: "outline",
                                    onClick: onClickPreview,
                                    className: _editTopNavmodulecss.default.btnPreview,
                                    children: "Preview"
                                }),
                                /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Tooltip, {
                                    withArrow: true,
                                    position: "bottom",
                                    label: "Discard all edits and return to outlet details",
                                    zIndex: 405,
                                    children: /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Button, {
                                        variant: "outline",
                                        onClick: onClickDiscard,
                                        className: _editTopNavmodulecss.default.btnDiscard,
                                        children: "Discard changes"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Tooltip, {
                                    withArrow: true,
                                    position: "bottom",
                                    label: "Save draft and return to outlet details",
                                    disabled: !isEdited || invalidSections,
                                    zIndex: 405,
                                    children: /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Button, {
                                        onClick: onClickSave,
                                        className: _editTopNavmodulecss.default.btnSave,
                                        disabled: !isEdited || invalidSections || hasIncompleteSections,
                                        children: "Save & exit"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Text, {
                            className: (0, _clsx.default)(_editTopNavmodulecss.default.subtitle),
                            "data-testid": "outlet-buttons-subtitle",
                            children: "These buttons apply changes to all sections below"
                        })
                    ]
                })
            })
        ]
    });
};
var _default = EditTopNav;
